var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHader),expression:"showHader"}],staticClass:"titArea"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._t("default"),(_vm.exposure)?_c('button',{staticClass:"btnPre",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1);}}},[_vm._v("이전으로")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }